// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { CUSTOMER_BY_ID } from "../config/api";
// import { useNavigate } from "react-router-dom";
// import EmailLogs from "../components/EmailLogs";
// export default function UserOne() {
//   const { id } = useParams();
//   const [customerData, setCustomerData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCustomerData = async () => {
//       try {
//         const response = await fetch(`${CUSTOMER_BY_ID}${id}`);
//         if (!response.ok) {
//           throw new Error("Failed to fetch data");
//         }
//         const data = await response.json();
//         setCustomerData(data);
//       } catch (error) {
//         setError(error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCustomerData();
//   }, [id]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div className="container">
//       <div className="card">
//         <div className="card-header">
//           <button
//             className="btn pill btn-secondary text-dark"
//             onClick={() => navigate(-1)}
//           >
//             <i className="mdi mdi-chevron-left m-0" />
//           </button>
//           <h4 className="pill">User</h4>
//         </div>
//         <div className="card-body">
//           <table className="table">
//             <tbody>
//               <tr>
//                 <td>
//                   <strong>Name</strong>
//                 </td>
//                 <td>{customerData.name}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Email</strong>
//                 </td>
//                 <td>{customerData.email}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Phone</strong>
//                 </td>
//                 <td>{customerData.phoneNumber}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Username</strong>
//                 </td>
//                 <td>{customerData.username}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Wallet Amount</strong>
//                 </td>
//                 <td>${customerData.walletAmount}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <strong>Change Password</strong>
//                 </td>
//                 <td>
//                   <button className="btn btn-danger text-white">
//                     Change Password
//                   </button>
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//       <EmailLogs />
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CUSTOMER_BY_ID } from "../config/api";
import { useNavigate } from "react-router-dom";
import EmailLogs from "../components/EmailLogs";

export default function UserOne() {
  const { id } = useParams();
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("profile"); // Manage active tab
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await fetch(`${CUSTOMER_BY_ID}${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCustomerData(data.meta);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <button
            className="btn pill btn-secondary text-dark"
            onClick={() => navigate(-1)}
          >
            <i className="mdi mdi-chevron-left m-0" />
          </button>
        </div>
        <div className="card-body">
          <div className="tab-buttons mb-4">
            <button
              className={`btn w-50 ${
                activeTab === "profile" ? "btn-info" : "btn-outline-info"
              }`}
              onClick={() => setActiveTab("profile")}
            >
              Profile
            </button>
            <button
              className={`btn w-50 ${
                activeTab === "emailLogs" ? "btn-info" : "btn-outline-info"
              }`}
              onClick={() => setActiveTab("emailLogs")}
            >
              Email Logs
            </button>
          </div>

          {/* Render based on active tab */}
          {activeTab === "profile" && (
            <table className="table">
              <tbody>
                <tr>
                  <td>
                    <strong>Name</strong>
                  </td>
                  <td>{customerData.name}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Email</strong>
                  </td>
                  <td>{customerData.email}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Phone</strong>
                  </td>
                  <td>{customerData.phoneNumber}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Username</strong>
                  </td>
                  <td>{customerData.username}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Wallet Amount</strong>
                  </td>
                  <td>${customerData.walletAmount}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Change Password</strong>
                  </td>
                  <td>
                    <button
                      className="btn btn-danger text-white"
                      data-toggle="modal"
                      data-target="#changePasswordModal"
                    >
                      Change Password
                    </button>

                    {/* Modal */}
                    <div
                      className="modal fade"
                      id="changePasswordModal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="changePasswordLabel"
                      aria-hidden="true"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="changePasswordLabel"
                            >
                              Change Password
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="form-group">
                                <label htmlFor="newPassword">
                                  New Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  id="newPassword"
                                  placeholder="Enter new password"
                                />
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Close
                            </button>
                            <button type="button" className="btn btn-danger">
                              Change
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {activeTab === "emailLogs" && <EmailLogs />}
        </div>
      </div>
    </div>
  );
}
